export default __webpack_public_path__ + "static/media/eye-icon.48d847fd.svg";